


// order-page-tab

function openTab(event, tabId) {
  // 1. Get all elements with class="tab-panel" and hide them
  const panels = document.getElementsByClassName("tab-panel");
  for (let i = 0; i < panels.length; i++) {
    panels[i].classList.remove("active");
  }

  // 2. Get all elements with class="tab-btn" and remove the class "active"
  const buttons = document.getElementsByClassName("tab-btn");
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].classList.remove("active");
  }

  // 3. Show the current tab panel, and add an "active" class to the button that opened the tab
  document.getElementById(tabId).classList.add("active");
  event.currentTarget.classList.add("active");
}


// checkbox code
// order package switch + checkout (combined)

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1];
}

document.addEventListener('DOMContentLoaded', function () {

  (function () {

    'use strict';

    // ============================================
    // CONFIG: Links + Pricing per variant
    // ============================================

var paramss = new URLSearchParams(window.location.search);
const affliateId =
    paramss.get("affId") ||
    paramss.get("aff_id") ||
    paramss.get("affid") ||
    "";
 

const VARIANT_CONFIG = {

  // Subscribe & Save
  '45046129361104': {link: `https://secure.myalphatonic.com/?products=8464153510096:45046129361104:1;8463154872528:45039503573200:1;8463154905296:45039503605968:1&cur=USD&ts=${affliateId}`, perBottle: 59, total: 59, strike: 99, save: 40},

  '45046129393872': {link: `https://secure.myalphatonic.com/?products=8464153510096:45046129393872:1;8463154872528:45039503573200:1;8463154905296:45039503605968:1&cur=USD&ts=${affliateId}`, perBottle: 49, total: 147, strike: 297, save: 150},

  '45046129492176': {link: `https://secure.myalphatonic.com/?products=8464153510096:45046129492176:1;8463154872528:45039503573200:1;8463154905296:45039503605968:1&cur=USD&ts=${affliateId}`, perBottle: 39, total: 195, strike: 495, save: 300},

  // One-Time
  '45046129656016': {link: `https://secure.myalphatonic.com/?products=8464153575632:45046129656016:1;8463154872528:45039503573200:1;8463154905296:45039503605968:1&cur=USD&ts=${affliateId}`, perBottle: 69, total: 69, strike: 99, save: 30},

  '45046129688784': {link: `https://secure.myalphatonic.com/?products=8464153575632:45046129688784:1;8463154872528:45039503573200:1;8463154905296:45039503605968:1&cur=USD&ts=${affliateId}`, perBottle: 59, total: 177, strike: 297, save: 120},

  '45046129721552': {link: `https://secure.myalphatonic.com/?products=8464153575632:45046129721552:1;8463154872528:45039503573200:1;8463154905296:45039503605968:1&cur=USD&ts=${affliateId}`, perBottle: 49, total: 245, strike: 495, save: 250}
};



     const DEFAULT_BOTTLE_ON_SWITCH = 5;
    // ============================================
    // DOM
    // ============================================

    const root = document.getElementById('purchase-block');
    if (!root) return;

    const pkgGroups = root.querySelectorAll('.pv-pkg');

    const totalEl = root.querySelector('.pv-pkg_total');
    const strikeEl = root.querySelector('.pv-pkg__strike');
    const saveEl = root.querySelector('.pv-pkg_save');

    const variantInput = document.getElementById('pv-variant-id');
    const form = document.getElementById('pv-product-form');

    const paymentCancel = document.querySelector('.payment_cancel');

    const refillCheckbox = root.querySelector(
      '.refill-container input[type="checkbox"]'
    );

    // ============================================
    // FORCE CHECKBOX CHECKED ON PAGE LOAD
    // ============================================

    if (refillCheckbox) {
      refillCheckbox.checked = true;
    }

    // ============================================
    // STATE
    // ============================================

   const state = {

      mode: 'subscribe',

      selectedBottle: DEFAULT_BOTTLE_ON_SWITCH

    };

    // ============================================
    // HELPERS
    // ============================================

    const fmt = (n) =>
      Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`;

    const getActiveGroup = () =>
      root.querySelector(`.pv-pkg[data-group="${state.mode}"]`);

    // ============================================
    // UPDATE
    // ============================================

    function update() {

      // Show active package group
      pkgGroups.forEach(group => {
        group.classList.toggle(
          'active',
          group.dataset.group === state.mode
        );
      });

      const activeGroup = getActiveGroup();
      if (!activeGroup) return;

      let activeOption = null;

      // Keep selected bottle when switching
      if (state.selectedBottle) {
        activeOption = activeGroup.querySelector(
          `.pv-pkg__opt[data-bottle-number="${state.selectedBottle}"]`
        );
      }

      // Otherwise use existing active option
      if (!activeOption) {
        activeOption =
          activeGroup.querySelector('.pv-pkg__opt.is-active') ||
          activeGroup.querySelector('.pv-pkg__opt');
      }

      if (!activeOption) return;

      // Remove active class from current group
      activeGroup.querySelectorAll('.pv-pkg__opt').forEach(opt => {
        opt.classList.remove('is-active');
      });

      // Add active class
      activeOption.classList.add('is-active');

      state.selectedBottle = parseInt(
        activeOption.dataset.bottleNumber,
        10
      );

      const variantId = activeOption.dataset.variantId;
      const config = VARIANT_CONFIG[variantId];

      if (!config) return;

      // Update hidden variant
      if (variantInput) {
        variantInput.value = variantId;
      }

      // Update pricing
      if (totalEl) {
        totalEl.textContent = fmt(config.total);
      }

      if (strikeEl) {
        strikeEl.textContent = fmt(config.strike);
      }

      if (saveEl) {
        saveEl.textContent = fmt(config.save);
      }

      // Update checkout URL
      if (form) {
        form.dataset.checkoutUrl = config.link;
      }

      // Payment cancel visibility
      if (paymentCancel) {
        if (state.mode === 'subscribe') {
          paymentCancel.classList.add('show_payment-cancel');
        } else {
          paymentCancel.classList.remove('show_payment-cancel');
        }
      }
    }

    // ============================================
    // CHECKBOX TOGGLE
    // ============================================

    function updateModeFromCheckbox() {

      if (!refillCheckbox) return;

      state.mode = refillCheckbox.checked
        ? 'subscribe'
        : 'onetime';

      update();
    }

    if (refillCheckbox) {
      refillCheckbox.addEventListener('change', updateModeFromCheckbox);
    }

    // ============================================
    // PACKAGE SELECTION
    // ============================================

    root.addEventListener('click', function (e) {

      const opt = e.target.closest('.pv-pkg__opt');

      if (!opt) return;

      const activeGroup = getActiveGroup();

      if (!activeGroup || !activeGroup.contains(opt)) return;

      state.selectedBottle = parseInt(
        opt.dataset.bottleNumber,
        10
      );

      update();
    });

    // ============================================
    // FORM SUBMIT
    // ============================================

form.addEventListener('submit', function (e) {
    e.preventDefault();

    const currentS1 =
        getCookie('tdl_default_12') ||
        paramss.get('c1') ||
        '';

    const url =
        form.dataset.checkoutUrl +
        `&s1=${encodeURIComponent(currentS1)}`;

    window.location.href = url;
});



    // ============================================
    // INITIAL LOAD
    // ============================================

    window.addEventListener('load', function () {

      if (refillCheckbox) {
        refillCheckbox.checked = true;
      }

      state.mode = 'subscribe';

      update();
    });

  })();

});



